import { render, staticRenderFns } from "./matrixScoreChart.vue?vue&type=template&id=96cc2a04&scoped=true&"
import script from "./matrixScoreChart.vue?vue&type=script&lang=js&"
export * from "./matrixScoreChart.vue?vue&type=script&lang=js&"
import style0 from "./matrixScoreChart.vue?vue&type=style&index=0&id=96cc2a04&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cc2a04",
  null
  
)

export default component.exports